import React, { ReactNode } from "react";
import { Box, ThemeUICSSObject } from "theme-ui";

const AbsoluteOverlay = ({
  style,
  children,
}: {
  style?: ThemeUICSSObject;
  children?: ReactNode;
}) => {
  return (
    <Box
      sx={{
        position: "absolute",
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...style,
      }}
    >
      {children}
    </Box>
  );
};

export default AbsoluteOverlay;
